<div
  class="border-gray-300 last:border-0 border-b"
  [ngClass]="{
    'pb-3': isTicketFeeEnabled,
  }">
  <div
    data-cy="cart-seat-item"
    class="flex justify-around items-center px-2 py-1 max-w-full h-14">
    <h5 class="md:ml-2 font-bold">
      <span class="mr-1 font-normal text-gray-500">Section</span>
      @if (!data.seat_row && data.seat) {
        {{
          data.section.includes('_')
            ? data.section.split('_')[1].split('-')[0]
            : data.section
        }}
      } @else {
        {{
          data.original_id.includes('_')
            ? data.original_id.split('_')[1].split('-')[0]
            : data.original_id
        }}
      }
    </h5>
    <h5 class="font-bold">
      <span class="mr-1 ml-1 font-normal text-gray-500">Row</span>
      @if (data.seat_row && data.seat) {
        {{ data.seat_row || '' }}
      } @else {
        {{ 'GA' }}
      }
    </h5>
    <h5 class="font-bold">
      <span class="mr-1 ml-1 font-normal text-gray-500">Seat</span>
      @if (data.seat_row && data.seat) {
        {{ data.seat || '' }}
      } @else {
        {{ seatIndex + 1 }}
      }
    </h5>
    <div class="flex items-center">
      <button
        data-cy="cart-seat-item-remove-button"
        class="hover:bg-gray-200 disabled:opacity-30 ml-2 md:ml-2 disabled:hover:transform-none hover:scale-95 transition-transform btn-icon"
        (click)="removeSeat()">
        <img src="/assets/img/delete-bin-icon.svg" alt="delete bin icon" />
      </button>
      <!-- No siempre llegan seat definition pa la silla por lo que si no tiene pa que enseñar nada
                  si no tiene definicioens mostramos el icono antigo de las adas. -->
      @if (hasSeatDefinition()) {
        <div class="ml-1 md:ml-2 btn-icon">
          <button
            (click)="openSeatDefinition()"
            class="disabled:opacity-30 disabled:hover:transform-none hover:scale-95 transition-transform btn-icon">
            <img
              src="/assets/img/information-icon-blue.svg"
              alt="location icon" />
          </button>
        </div>
      } @else {
        @if (getSeatAvailability().isAda) {
          <div class="ml-1 md:ml-2 btn-icon">
            <img
              src="/assets/img/accessible-icon.svg"
              alt="accessible seating" />
          </div>
        }
      }
      <div class="ml-1 md:ml-2 btn-icon">
        <button
          (click)="open3dView()"
          class="bg-white hover:bg-gray-200 disabled:opacity-30 disabled:hover:transform-none hover:scale-95 transition-transform btn-icon">
          <img src="/assets/img/feather-eye.svg" alt="location icon" />
        </button>
      </div>
    </div>
  </div>

  <ng-container>
    @if (isTicketFeeEnabled && data.totalPriceWithFees) {
      <div
        class="flex justify-between items-center bg-main-blue01 mx-3 p-2 rounded-xl text-main-blue text-xs">
        <div>
          <span class="mr-1">Ticket Price</span>
          <span class="mr-1 font-bold">
            ${{ data.price | number: '1.2-2' }}</span
          >
          +
          <span class="mr-1">Fees</span>
          <span class="font-bold"> ${{ data.totalFee | number: '1.2-2' }}</span>
        </div>
        <div class="font-bold">
          <span class="mr-1">Total:</span>
          <span> ${{ data.totalPriceWithFees | number: '1.2-2' }}</span>
        </div>
      </div>
    }
  </ng-container>
</div>
